module.exports = __webpack_public_path__ + "img/Tez Capital and Finance.8309a6c6.png";